import React from 'react';
import {_GPY,__GPYPost} from '../../env.js'

import FreeText from './overlays/FreeText';
import Crawl from './overlays/Crawl';
import Credits from './overlays/Credits';
import LineUp from './overlays/LineUp';
import Overlay from './overlays/Overlay'
import Bowl from './overlays/Bowl'
import AnalogClock from './overlays/AnalogClock'

import Helper from '../Helper.js';
import Wait from './../../Wait';
import GuppyiBranding from './overlays/GuppyiBranding'



import BasketballMapping from './mappings/BasketballMapping.js';
import BowlingMapping from './mappings/BowlingMapping.js';
import DriftMapping from './mappings/DriftMapping.js';
import HockeyMapping from './mappings/HockeyMapping.js';
import IceHockeyMapping from './mappings/IceHockeyMapping.js';
import IncastContentTVMapping from './mappings/IncastContentTVMapping.js';
import SoccerFootballMapping from './mappings/SoccerFootballMapping.js';
import VolleyballMapping from './mappings/VolleyballMapping.js';

const __wildCardString = "-s_t_a_r-";

const __layoutComponentes = {
  crawl:Crawl,
  freetext:FreeText,
  lineup:LineUp,
  overlay:Overlay,
  bowl:Bowl,
  credits:Credits,
}


class Display extends React.Component {

  elementCache = {};
  __autoReconnect = true;

  constructor(props) {
      super(props);

      this.state = {
        debug : true,
        cmd:"",
        overlaysIsLoaded: false,
        overlays: {},
        eventListener:{},
        defaultValuesLoaded:false,
        gameStates:{},
        connection:undefined,
      };
      console.log(this.state);
   }

   dismiss() {
      console.log("DEMISS: DISPLAY");
   }

   componentDidMount() {
     this.__autoReconnect = true;
_GPY.loadFonts(()=>{

     if(this.props.scoreboard !== undefined && this.props.stateName !== undefined ){
        this.props.scoreboard.registerComponent(this.props.stateName,this);
     };

     let c = this.createConnection();
     this.setState({connection : c});

     if(this.props.layoutId !== undefined){
       this.getOverlays(this.props.layoutId);
     } else {
       this.getOverlays(-1);
     }

     __GPYPost('getGameState',{},(res) => {
       let allStates = res.GameState.values;

       Object.keys(allStates).forEach(key => {
         if(allStates[key].startsWith('{')){
           allStates[key] = JSON.parse(allStates[key]);
         }
       });
       this.setState( {gameStates: res.GameState.values, defaultValuesLoaded : true} );
     });

     if(this.props.overflow==="hidden"){
       const bg = new URLSearchParams(window.location.search).get('_bg');
       console.log("BG",bg);
       if(bg!==undefined && bg!=="") {
          this.setHidden("OVER","body {overflow:hidden; background-color: #"+bg+"}");
       } else {
         this.setHidden("OVER","body {overflow:hidden}");
       }

     }
});

   }

   componentWillUnmount(){
      this.closeWSConnection();
   }

   isLiveTV() {
     return _GPY.uiStates.gameType === "LiveTV";
   }

   setHidden(styleName, css) {

       var styleElement = document.getElementById(styleName);
       if (styleElement) document.getElementsByTagName('head')[0].removeChild(styleElement);

       styleElement = document.createElement('style');
       styleElement.type = 'text/css';
       styleElement.id = styleName;
       styleElement.innerHTML = css;

       document.getElementsByTagName('head')[0].appendChild(styleElement);
   }

   reconnect() {
     console.log("WebSocketReconnect:",this.__autoReconnect);
     clearInterval(this.interval);
     this.interval = undefined;

     if(this.__autoReconnect){
       let c = this.createConnection();
       this.setState({connection : c});
     }
   }

   closeWSConnection() {
     this.__autoReconnect=false;
       let con = this.state.connection;
       if(con!==undefined){
          if(con.readyState === WebSocket.OPEN) {
             con.send("_CLOSE::byClient");
             con.close();
        }
       }
   }

   sendMeStateInfo(stateName) {
     let con = this.state.connection;
     if(con!==undefined){
         console.log("CONNECTION:",con.readyState);
        if(con.readyState === WebSocket.OPEN) {
          con.send("_GETBACK::"+stateName);
        }
     }
  }

  getOverlays( id ) {
  //  console.log("getOverlays",id);
    var w = parseFloat( this.props.width);
    var h = parseFloat(this.props.height);

    __GPYPost('getOverlays', {layoutPk : id } , (res)=>{

      Object.keys(res.Overlays.overlay).forEach(key => {
        //console.log(key,res.Overlays.overlay[key].overlay);
        Object.keys(res.Overlays.overlay[key].overlay.elements).forEach(eKey => {
             var e = res.Overlays.overlay[key].overlay.elements[eKey].element;
             e.x = Helper.toXPos(parseFloat(e.x) , w);
             e.y = Helper.toYPos(parseFloat(e.y) , h);
             e.width = Helper.toXPos(parseFloat(e.width) , w);
             e.height = Helper.toYPos(parseFloat(e.height) , h);
             e.fontSize = Helper.toScaleValue(parseFloat(e.fontSize) , h);
        });
      });
      this.setState({
        overlaysIsLoaded: true,
        overlays: res.Overlays.overlay,
      },()=>{
        Object.keys(this.state.eventListener).forEach(key => {
            var c = this.state.eventListener[key];
            // console.log("Notify:",key);
            for (var i = 0; i < c.length; i++) {
                  if(c[i].updateOverlay !== undefined){
                      c[i].updateOverlay();
                  }
            }
        });
      });
    });
  }

  registDataListener(name,listener) {
    var e = this.state.eventListener;
    if(e[name] === undefined){
        e[name] = [];
    }
    e[name].push(listener);
    this.setState({eventListener:e});
  }

   createConnection() {
        console.log("connect:",_GPY.webSocket);

        var connection = new WebSocket(_GPY.webSocket);
        connection.onopen =  () => {
          	  console.log('WebSocket: connected');
              console.log("init::"+_GPY.uiStates.guppyiId);
              connection.send("init::"+_GPY.uiStates.guppyiId);

              console.log("clientInfo::" + _GPY.clientInfo() );
              connection.send("clientInfo::" + _GPY.clientInfo() );
        };
        connection.onerror = (error) => {
              console.log("autoReconnect ERROR",error);
              if(this.interval === undefined ) {
                this.interval = setInterval(() => this.reconnect(), (2 * 1000));
              }
        };
        connection.onclose = (error) => {
              console.log("autoReconnect CLOSE",error);
              if(this.interval === undefined) {
                this.interval = setInterval(() => this.reconnect(), (2 * 1000));
              }
        };

        connection.onmessage =  (e) => {

          var v = e.data.split("::");
          if(v[0] === '__RELOAD_OVERLAYCONFIG' && v[1] === 'NOW') {
            if(this.props.layoutId !== undefined){
              this.getOverlays(this.props.layoutId);
            } else {
              this.getOverlays(-1);
            }
          } else {
              if(v[0]==="OK"){
                  console.log("onmessage",v[0],v[1]);
              } else {
                  var json = JSON.parse(v[1]!==undefined&&v[1]!==''?v[1]:"{}");
                  console.log("onmessage",v[0],json);
                  if(this.props.onData !== undefined) {
                    this.props.onData(json,v[0]);
                  }

                  if(this.state.eventListener[v[0]]!==undefined){
                    var c = this.state.eventListener[v[0]]
                    for (var i = 0; i < c.length; i++) {
                      if(c[i].onData !== undefined ){
                         c[i].onData(json,v[0]);
                      }
                    }
                  } else if(this.state.eventListener[v[0]+"_timeout"]!==undefined){
                    var ca = this.state.eventListener[v[0]]
                    for (var ia = 0; i < ca.length; ia++) {
                      if(ca[ia].onSetTimeout !== undefined ){
                         ca[ia].onSetTimeout(json,v[0]);
                      }
                    }
                  } else if(this.state.eventListener[v[0]+"_init"]!==undefined){
                    var cb = this.state.eventListener[v[0]]
                    for (var ib = 0; ib < cb.length; ib++) {
                      if(cb[ib].onInit !== undefined ){
                         cb[ib].onInit(json,v[0]);
                      }
                    }
                  } else {
                    Object.keys(this.state.eventListener).forEach((item, i) => {
              //        console.log("TRY TO FIND:",item,item.endsWith(__wildCardString));
                      if(item.endsWith(__wildCardString)) {
                        var subkey = item.substring(0,item.length-__wildCardString.length);
              //          console.log("SUBKEY:",subkey);
                        var json = JSON.parse(v[1]!==undefined&&v[1]!==''?v[1]:"{}");
                        if( v[0].startsWith(subkey) ){
                            var c = this.state.eventListener[item]
                            for (var bb = 0; bb < c.length; bb++) {
                              if(c[bb].onData !== undefined ){
                             //  console.log("onData:",item,json);
                                 c[bb].onData(json,item);
                              }
                            }
                          }
                      }
                    });
                  }
              }
          }
          this.forceUpdate();
        };

        return connection;
    }

    toXPos(fkValue) {
		  return Helper.toXPos(fkValue, this.props.width);
  	}
  	toYPos(fkValue) {
  		return Helper.toYPos(fkValue, this.props.height);
  	}

    toScaleValue(fkValue){
       var p = 100 / 2160 * this.props.height;
       return Math.floor(fkValue * p / 100);
    }



    render() {
      const seen = [];
      if( ! this.state.overlaysIsLoaded || !this.state.defaultValuesLoaded) {
        return (<Wait width={this.props.width} height={this.props.height} message="Connecting -.."/>)
      }
      var theme = "default";

      return (
        <div className="m-0" style={{overflow:"hidden", width: this.props.width+"px", height: this.props.height+"px", backgroundColor:this.props.backgroundColor === undefined ? "#555" : this.props.backgroundColor}}>


            {_GPY.uiStates.userLvl < _GPY.USER_PRO && !this.isLiveTV()?
              <div style={{position :"absolute",zIndex:"5000",left:this.toXPos(87)+"px",top : this.toYPos(5)+"px",width : this.toXPos(8)+"px",height :this.toYPos(8)+"px",display:"inline",opacity:"1.0"}}>
              <img alt="GUPPYI LOGO" className="image-fluid" style={{maxWidth : "100%", maxHeight : "100%", display:"inline", opacity:"1.0"}} src={_GPY.resource("images/guppyi_logo.png")}/>
              </div>
            :""}

            <IncastContentTVMapping display={this} theme={theme}/>
            <SoccerFootballMapping display={this} theme={theme}/>

            {Object.entries(this.state.overlays).map((elem) => {
              if(elem[1].overlay.eventName!==undefined) {
                  var keys = elem[1].overlay.eventName.split(",");
                    return keys.map( (k) => {
                        if(k!==undefined&&k!=="") {
                          if(seen.includes(k)) {
                              return (<span className="text-danger">duplicate stateName: {k}<br/></span>);
                          } else {
                              seen.push(k);
                              if(k.includes('*')) {
                                k=k.substring(0,k.length-1)+__wildCardString;
                              }
                                // return (<span className="text-danger">-->{k}:{elem[1].overlay.layouter.toLowerCase()}<br/></span>);

                              if(this.elementCache[k]!==undefined) {
                                return this.elementCache[k];
                              } else {


                              console.log("NEW ELEMENT:",k,elem[1].overlay.layouter.toLowerCase());
                              const elm =  React.createElement(__layoutComponentes[elem[1].overlay.layouter.toLowerCase()], {
                                  key: k,
                                  zindex: elem[1].overlay.zindex,
                                  stateName:k,
                                  display: this,
                                  theme:theme,
                                  overlayConf:elem[0]
                              });
                              this.elementCache[k]=elm;
                              return elm;
                                }
                          }
                        }
                        return "";
                     }
                   );
                 }
                 return "";
            })}

            {_GPY.uiStates.userLvl<_GPY.USER_PRO&&!this.isLiveTV()?<GuppyiBranding display={this}/>  :""}
            </div>
  );
 }
}
export default Display;
